import { useFeatureFlags } from '@funtech-int/yango-shared';

import { useInstanceEffect } from '@/scenarios/legacy-player/hooks/useInstanceEffect';

import { usePlayerPrerollStarted } from '../../analytics/hooks/use-player-preroll-started';

interface Params {
    prerollDuration: number;
    contentId: string;
    eventParamsBuilder: Parameters<typeof usePlayerPrerollStarted>[1];
}

export const usePrerollAnalytics = ({ prerollDuration, contentId, eventParamsBuilder }: Params) => {
    const { flags } = useFeatureFlags();
    const prerollsSupported = flags.get('isDynamicPrerollEnabled', 'boolean', false);

    const trackPrerollStarted = usePlayerPrerollStarted(
        {
            mainUuid: contentId,
            prerollsSupported,
        },
        eventParamsBuilder
    );

    useInstanceEffect(
        (instance) => {
            if (prerollDuration > 0) {
                const unsubscribeFromOnPrerollImpression = instance.onContentImpression(() =>
                    trackPrerollStarted({ vsid: instance.vsid ?? '' })
                );

                return () => {
                    unsubscribeFromOnPrerollImpression();
                };
            }
        },
        [trackPrerollStarted]
    );
};
